module.exports = __webpack_public_path__ + "98174510313ddb16652091c010da3c4d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/story_scroll.png
 ** module id = 276
 ** module chunks = 0
 **/